import { BlogPagePreview } from './blogQueries';
import { usePageDataset } from '../../../templates/PageDatasetsContext';

export const useResearch = (required = true): BlogPagePreview[] => {
    // i had updated to support in pagetype before case_study if anything breaks update the pagetype to support
    return usePageDataset('pageResearch', required)?.nodes ?? [];
};
